import guid from '../../node_modules/@imp/package/lib/zyb-yike-utils/guid'
import qdStorageExtend from './qdStorageExtend'
import { platform } from '../../node_modules/@imp/package/lib/utils/platform'

let isInApp = platform.isInApp

export function getCuid() {
  // 端外环境生成一个尽量唯一的标识，对标端上的cuid
  var cuidItem = 'yikeLogCuid'
  var cuid = qdStorageExtend.localStorage.getItem(cuidItem)
  if (!isInApp && !cuid) {
    cuid = guid(32)
    qdStorageExtend.localStorage.setItem(cuidItem, cuid)
  }
  return cuid
}

export default {
  getCuid,
}
